<template>
  <div class="main-navbar__wrapper" v-if="!$mob">
    <div class="main-navbar__boxinfo">
      <img
        class="main-navbar__boxinfo-logo"
        alt="Vue logo"
        src="@/assets/images/logo_jsm.png"
      />
      <h1 class="main-navbar__boxinfo-pagename">Loja virtual</h1>
    </div>
    <div class="main-navbar__usermenu">
      <user-logo class="main-navbar__usermenu-icon"></user-logo>
      <p class="main-navbar__usermenu-username">{{ user && user.name }}</p>
      <p @click="logout" class="main-navbar__logout">Sair</p>
    </div>
  </div>
</template>

<script>
import UserLogo from '@/assets/images/user-inverse.svg'
import { FEATURE_FLAG } from '@/enums/feature-flag'
import { storageKeys } from '@/enums/storageKeys'
import auth0 from '@/helpers/auth0/auth0'
import { unleash } from '@/plugins/unleash/unleash'

export default {
  components: {
    UserLogo,
  },

  mounted() {
    this.user = this.$persistence.get(storageKeys.USER_INFO)
  },

  data() {
    return {
      user: '',
    }
  },

  methods: {
    logout() {
      this.$persistence.clear()
      const isAuth0LoginEnabled = unleash.isEnabled(
        FEATURE_FLAG.RELEASE_LV_ADMIN_AUTH0_LOGIN
      )

      if (isAuth0LoginEnabled) {
        auth0.logout()
      } else {
        this.$router.push({ name: 'Login' })
      }
      this.$checkUserRoles()
    },
  },
}
</script>

<style src="./MainNavbar.scss" scoped lang="scss" />
